import types from './types';

const setCurrentIncident = incident => ({
  type: types.SET_INCIDENT,
  payload: {
    incident
  }
});

const setCurrentIncidentStats = stats => ({
  type: types.SET_INCIDENT_STATS,
  payload: {
    stats
  }
});

const setIncidentFields = fields => ({
  type: types.SET_INCIDENT_FIELDS,
  payload: {
    fields
  }
});

const setIncidentHistoryFields = fields => ({
  type: types.SET_INCIDENT_HISTORY_FIELDS,
  payload: {
    fields
  }
});

const setIncident209ResourcesFields = fields => ({
  type: types.SET_INCIDENT_209_RESOURCES_FIELDS,
  payload: {
    fields
  }
});

const clearCurrentIncident = () => ({
  type: types.CLEAR_INCIDENT
});

const setInitialIncidentFilter = filterState => ({
  type: types.SET_INITIAL_INCIDENT_FILTER,
  payload: {
    filterState
  }
});

const updateIncidentFilterValues = filter => ({
  type: types.UPDATE_INCIDENT_FILTER_VALUES,
  payload: {
    ...filter
  }
});

const updateIncidentSqlFilter = sql => ({
  type: types.UPDATE_INCIDENT_SQL_FILTER,
  payload: {
    sql
  }
});

const clearIncidentFilters = filter => ({
  type: types.CLEAR_INCIDENT_FILTERS,
  payload: {
    ...filter
  }
});

const setInitialIncidentListColumns = columns => ({
  type: types.SET_INITIAL_INCIDENT_LIST_COLUMNS,
  payload: {
    columns
  }
});

const addIncidentListColumn = (columnName, indexPosition) => ({
  type: types.ADD_INCIDENT_LIST_COLUMN,
  payload: {
    columnName,
    indexPosition
  }
});

const removeIncidentListColumn = columnName => ({
  type: types.REMOVE_INCIDENT_LIST_COLUMN,
  payload: {
    columnName
  }
});

const setInitialIncidentResourceListColumns = columns => ({
  type: types.SET_INITIAL_INCIDENT_RESOURCE_LIST_COLUMNS,
  payload: {
    columns
  }
});

const addIncidentResourceListColumn = (columnName, indexPosition) => ({
  type: types.ADD_INCIDENT_RESOURCE_LIST_COLUMN,
  payload: {
    columnName,
    indexPosition
  }
});

const removeIncidentResourceListColumn = columnName => ({
  type: types.REMOVE_INCIDENT_RESOURCE_LIST_COLUMN,
  payload: {
    columnName
  }
});

const setInitialIncidentRequestListColumns = columns => ({
  type: types.SET_INITIAL_INCIDENT_REQUEST_LIST_COLUMNS,
  payload: {
    columns
  }
});

const addIncidentRequestListColumn = (columnName, indexPosition) => ({
  type: types.ADD_INCIDENT_REQUEST_LIST_COLUMN,
  payload: {
    columnName,
    indexPosition
  }
});

const removeIncidentRequestListColumn = columnName => ({
  type: types.REMOVE_INCIDENT_REQUEST_LIST_COLUMN,
  payload: {
    columnName
  }
});

const setInitialIncidentExperienceListColumns = columns => ({
  type: types.SET_INITIAL_INCIDENT_EXPERIENCE_LIST_COLUMNS,
  payload: {
    columns
  }
});

const addIncidentExperienceListColumn = (columnName, indexPosition) => ({
  type: types.ADD_INCIDENT_EXPERIENCE_LIST_COLUMN,
  payload: {
    columnName,
    indexPosition
  }
});

const removeIncidentExperienceListColumn = columnName => ({
  type: types.REMOVE_INCIDENT_EXPERIENCE_LIST_COLUMN,
  payload: {
    columnName
  }
});

const setHistoryLoading = loading => ({
  type: types.SET_HISTORY_LOADING,
  payload: {
    ...loading
  }
});

const setHistoryIncidents = incidents => ({
  type: types.SET_HISTORY_INCIDENTS,
  payload: {
    ...incidents
  }
});

const setHistoryIsMore = isMore => ({
  type: types.SET_HISTORY_IS_MORE,
  payload: {
    ...isMore
  }
});

const setHistoryIncidentCount = incidentCount => ({
  type: types.SET_HISTORY_INCIDENT_COUNT,
  payload: {
    ...incidentCount
  }
});

const setHistoryShowDataGrid = showDataGrid => ({
  type: types.SET_HISTORY_SHOW_DATA_GRID,
  payload: {
    ...showDataGrid
  }
});

export default {
  setCurrentIncident,
  setCurrentIncidentStats,
  setIncidentFields,
  setIncidentHistoryFields,
  setIncident209ResourcesFields,
  clearCurrentIncident,
  setInitialIncidentFilter,
  updateIncidentFilterValues,
  updateIncidentSqlFilter,
  clearIncidentFilters,
  setInitialIncidentResourceListColumns,
  addIncidentResourceListColumn,
  removeIncidentResourceListColumn,
  setInitialIncidentExperienceListColumns,
  addIncidentExperienceListColumn,
  removeIncidentExperienceListColumn,
  setInitialIncidentRequestListColumns,
  addIncidentRequestListColumn,
  removeIncidentRequestListColumn,
  setInitialIncidentListColumns,
  addIncidentListColumn,
  removeIncidentListColumn,
  setHistoryLoading,
  setHistoryIncidents,
  setHistoryIsMore,
  setHistoryIncidentCount,
  setHistoryShowDataGrid
};



// WEBPACK FOOTER //
// ./src/redux/incident/actions.js